import styled from 'styled-components';
import Tooltip from '../../HOC/Tooltip/Tooltip';
import { ITheme } from '../../styles/theme';

interface IProgressBarCont {
  theme: ITheme;
  width?: string;
  height?: string;
  contWidth?: string;
  barMode: 'weak' | 'normal' | 'strong';
  background?: string;
}

export const ProgressBarCont = styled.div<IProgressBarCont>`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  ${({ theme, width, barMode, height, contWidth, background }: IProgressBarCont) => `
      width: ${contWidth || '376px'};
      height: ${height || '16px'};
      background: ${background || theme.colors.neutral.primary[10]};
      border-radius: 4px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: ${width || '376px'};
        height: ${height || '16px'};
        background ${
  barMode === 'strong'
    ? theme.colors.accent.green[70]
    : barMode === 'normal'
      ? theme.colors.accent.blue[70]
      : theme.colors.accent.red[70]
};
        border-radius: 4px;
        transition: width 0.1s ease-in-out;
      }
  `}
`;

interface IHistoricalScoreTooltip {
  contWidth?: string;
  historicalScore: number;
}

export const HistoricalScoreTooltip = styled(Tooltip)<IHistoricalScoreTooltip>`
  position: absolute;
  top: 0;
  cursor: pointer;

  [id='TooltipBody'] {
    display: flex;
    justify-content: center;
    white-space: nowrap;
  }

  ${({ contWidth, historicalScore }: IHistoricalScoreTooltip) => `
    left: calc((${historicalScore} / 100 * ${contWidth}) - 1px);
  `}
`;

interface IHistoricalScore {
  theme: ITheme;
  height?: string;
}

export const HistoricalScore = styled.span<IHistoricalScore>`
  width: 2px;
  border-radius: 1px;

  ${({ height, theme }: IHistoricalScore) => `
    height: ${height || '16px'};
    background: ${theme.colors.secondary[100]};
  `}
`;
